<template>
  <form @submit.prevent="">
    <z-dialog :show="isVisible" :modal-size="modalSize">
      <template #header>
        <div class="custom-header">
          <div class="row">
            <div class="col-md-11">
              <h4 class="modal-title">
                {{ title }}
              </h4>
            </div>
            <div class="col-md-1">
              <a href="#" class="custom-close" @click="close">
                <i class="fa fa-times"></i>
              </a>
            </div>
          </div>
        </div>
      </template>
      <template #body>
        <div class="hostWrapper">
          <div v-if="currentTab === 'Basic'" class="row p-2">
            <div class="col">
              <opportunity-basic ref="opportunityBasic" :firm="firm" @changed="changed" @saved="saved" @export="export" @push="push" />
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="custom-footer">
          <div class="col-1">
            <span title="ids">{{ ids }}</span>
          </div>
          <div class="col">
            <button class="btn btn-primary" @click="push">Push</button>
            <button class="btn btn-primary ms-2" @click="export">Export</button>
          </div>
          <div class="col custom-right-align">
            <button type="button" class="btn btn-light" @click="close()">Cancel</button>
            <button v-show="isSave" class="btn btn-danger ms-2" :disabled="isSaving" @click="save(false)">
              <span class="ms-2">Save</span>
            </button>
            <button v-show="isSave" class="btn btn-danger ms-2" :disabled="isSaving" @click="save(true)">
              <span class="ms-2">Save & Close</span>
            </button>
          </div>
        </div>
      </template>
    </z-dialog>
  </form>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { opportunityStore } from '@/stores/opportunity'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import ZTabs from '@/components/utilities/elements/Tabs.vue'
import OpportunityBasic from './OpportunityBasic.vue'
export default {
  name: 'OpportunityDialog',
  components: {
    ZDialog,
    ZTabs,
    OpportunityBasic
  },
  props: {
    modelValue: Object
  },
  data() {
    return {
      modalSize: 'modal-lgr',
      isSave: false,
      currentTab: 'Basic',
      isSaving: false
    }
  },
  emits: ['closing', 'saved'],
  computed: {
    ...mapState(opportunityStore, ['opportunity']),
    isVisible() {
      console.log('modelValue', {
        model: this.modelValue,
        opportunity: this.opportunity
      })
      return this.modelValue !== null
    },
    tabs() {
      let _tabs = ['Basic']
      return _tabs
    },
    title() {
      let _title = ''
      if (this.opportunity) {
        _title = `Opportunity #${this.opportunity.opportunity} for ${this.opportunity.firmName}`
      }
      return _title
    },
    ids() {
      let _ids = ''
      if (this.opportunity) {
        _ids = `${this.opportunity.opportunity}`
      }
      return _ids
    },
    firm() {
      let _id = null
      if (this.opportunity) {
        _id = this.opportunity.firm
      }
      return _id
    }
  },
  methods: {
    ...mapActions(opportunityStore, ['setOpportunity']),
    close() {
      this.isSave = false
      this.currentTab = 'Basic'
      this.$emit('closing')
    },
    setTab(value) {
      this.currentTab = value
    },
    changed() {
      this.isSave = true
    },
    saved() {
      this.isSave = false
      this.isSaving = false
    },
    export() {
      console.log('Export Opportunity')
    },
    push() {
      console.log('Push Opportunity')
    },
    async save(closeIt) {
      let response = null
      this.isSaving = true
      if (this.currentTab === 'Basic') {
        response = await this.$refs.opportunityBasic.save()
      }
      this.isSaving = false
      this.isSave = false
      this.$emit('saved', response)
      if (closeIt) {
        this.currentTab = 'Basic'
        this.$emit('closing')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-textarea {
  height: 200px;
}
.custom-close {
  float: right;
  margin-right: 10px;
  color: #000;
  cursor: pointer;
}
.custom-footer {
  width: 100%;
  display: inline-flex;
}
.custom-right-align {
  text-align: right;
}
.hostWrapper {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: auto;
  height: 600px;
}
</style>
